import { ADMIN, MANAGER, BACKOFFICE, AGENT, SUPPLIER, SUPERADMIN, FINANCIAL_ADMIN } from "../../Constantes/userRoles";
import dashboardIcon from "../../images/desktop-dashboard.svg";
import panelIcon from "../../images/panel-control.svg";
import casesIcon from "../../images/table.svg";
import billingIcon from "../../images/car-dollar.svg";
import documentIcon from "../../images/document.svg";
import campaignsIcon from "../../images/message.svg";
import workshopsIcon from "../../images/workshop-car.svg";
import fleetsIcon from "../../images/truck-front.svg";
import customersIcon from "../../images/customer.svg";
import itvsIcon from "../../images/technical-service.svg";

export const ROUTE_PANEL = "/";
export const ROUTE_CASES = "/cases";
export const ROUTE_BILLING = "/billing";
export const ROUTE_SUPPLIER_PAYMENT_ORDERS = "/supplier-payment-orders";
export const ROUTE_WORKSHOPS = "/workshops";
export const ROUTE_FLEET = "/fleet";
export const ROUTE_CLIENTS = "/clients";
export const ROUTE_ITVS = "/itv";
export const ROUTE_LOGIN= "/login";
export const ROUTE_FORCE_CHANGE_PASSWORD = "/force-change-password";
export const ROUTE_DASHBOARD = "/dashboard";
export const ROUTE_CAMPAIGN_STATISTICS = "/campaigns";

export const ROUTE_ADMINS_MENU = "/admin";
export const ROUTE_STATES = "/admin/states";
export const ROUTE_TAXONOMIES = "/admin/taxonomies";
export const ROUTE_ENTRY_CHANNEL = "/admin/entrychannel";
export const ROUTE_INTERACTION = "/admin/interaction";
export const ROUTE_USERS = "/admin/users";
export const ROUTE_EXCEPTIONS = "/admin/exceptions";
export const ROUTE_SUBSTATES = "/admin/subStates";
export const ROUTE_CONTRACT_DATA = "/admin/contractData";
export const ROUTE_TEMPLATES = "/admin/templates";
export const ROUTE_EXTERNAL_USERS = "/admin/externalUsers";
export const ROUTE_ADMIN_WORKSHOPS = "/admin/workshops";
export const ROUTE_ADMIN_FILE_MANAGEMENT = "/admin/fileManagement";
export const ROUTE_ADMIN_CAMPAIGN = "/admin/campaigns";
export const ROUTE_MAIL_MAPPERS = "/admin/mailMappers";
export const ROUTE_SERVICES = "/admin/services";
export const ROUTE_SUPPLIER = "/admin/supplier";
export const ROUTE_SUPPLIER_SERVICE_TYPE = "/admin/supplierServiceType";
export const ROUTE_CUSTOMER = "/admin/customer";

export const routeList = [
        {path: ROUTE_DASHBOARD, label: "Dashboard", translationMap: "Header.Menu.Dashboard", allowedRoles: [MANAGER, ADMIN, FINANCIAL_ADMIN], icon: dashboardIcon}, 
        {path: ROUTE_PANEL, label: "Painel", translationMap: "Header.Menu.Panel", allowedRoles: ["*"], icon: panelIcon}, 
        {path: ROUTE_CASES, label: "Casos", translationMap: "Header.Menu.Cases", allowedRoles: [ADMIN, MANAGER, AGENT, SUPERADMIN, FINANCIAL_ADMIN], icon: casesIcon},
        {path: ROUTE_BILLING, label: "Faturamento", translationMap: "Header.Menu.Billing", allowedRoles: [FINANCIAL_ADMIN, BACKOFFICE], strictRoles: true, icon: documentIcon},
        {path: ROUTE_SUPPLIER_PAYMENT_ORDERS, label: "Ordens de Pagamento", translationMap: "Header.Menu.SupplierPaymentOrders", allowedRoles: [SUPPLIER, ADMIN, FINANCIAL_ADMIN], icon: billingIcon},
        {path: ROUTE_CLIENTS, label: "Clientes", translationMap: "Header.Menu.Customers", allowedRoles: ["*"], icon: customersIcon},
];